'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');

const _element='body';
const _supportRedirectClass='support-redirect';

const _includes=function(arr,val){return arr.indexOf(val)!==-1};let

StateClassDirective=function(){function StateClassDirective(){_classCallCheck(this,StateClassDirective)}StateClassDirective.prototype.




factory=function factory($rootScope,elementService,Analytics,userService,redirectionService,fatigueMeterTypeContentProviderService){
return{
restrict:'A',
link:function(){
$rootScope.$on('$stateChangeSuccess',function(event,toState,toParams,fromState,fromParams){
const currentStateName='state-'+_.kebabCase(_.last(toState.name.split('.')));
const lastStateName='state-'+_.kebabCase(_.last(fromState.name.split('.')));

if(currentStateName==lastStateName){
return;
}

fastdom.measure(function(){
const currentClasses=elementService.classList(_element);

const removeClass=function(className){
if(_includes(currentClasses,className)){
elementService.removeClass(_element,className);
}
};

const addClass=function(className){
if(!_includes(currentClasses,className)){
elementService.addClass(_element,className);
}
};

fastdom.mutate(function(){
removeClass(lastStateName);
addClass(currentStateName);

if(redirectionService.helpCenterRedirectIsPending){
addClass(_supportRedirectClass);
}else{
removeClass(_supportRedirectClass);
}

const fatigueMeterType=fatigueMeterTypeContentProviderService.fatigueMeterType;

const fatigueMeterTypeClass=`fatigue-meter-${fatigueMeterType.value.toLowerCase()}`;
const fatigueMeterClasses=currentClasses.filter(function(c){return c.startsWith('fatigue-meter-')});
for(const className of fatigueMeterClasses){
if(className!==fatigueMeterTypeClass){
elementService.removeClass(_element,className);
}
}

addClass(fatigueMeterTypeClass);

Analytics.trackEvent('state','change',toState.name);
});
});
});
}};

};_createClass(StateClassDirective,null,[{key:'type',get:function(){return'directive'}}]);return StateClassDirective}();


module.exports=StateClassDirective;
module.exports.prototype.factory.$inject=['$rootScope','elementService','Analytics','userService','redirectionService','fatigueMeterTypeContentProviderService'];
//# sourceMappingURL=stateClassDirective.js.map
